export const GIFT_FLOW_RLP_ID = 0;
export const GIFT_FLOW_EXCHANGE_ID = 1;
export const GIFT_FLOW_SCHEDULE_ID = 2;
export const GIFT_FLOW_INFORMATION_ID = 3;
export const GIFT_FLOW_SHIPPING_ID = 4;
export const GIFT_FLOW_CONFIRMATION_ID = 5;
export const GIFT_FLOW_THANKS_ID = 6;
export const GIFT_FLOW_DONATE_ID = 7;

export const GIFT_FLOW_RPL_STEP = {
  id: GIFT_FLOW_RLP_ID,
  name: 'rpl',
  icon: '',
  route: '',
  isVisible: false,
};

export const GIFT_FLOW_EXCHANGE_STEP = {
  id: GIFT_FLOW_EXCHANGE_ID,
  name: 'exchange',
  icon: 'wrappedGift',
  route: 'marketplace',
  isVisible: true,
};

export const GIFT_FLOW_SCHEDULE_STEP = {
  id: GIFT_FLOW_SCHEDULE_ID,
  name: 'schedule',
  icon: 'spiralCalendar',
  route: 'accept/schedule',
  isVisible: true,
};

export const GIFT_FLOW_INFORMATION_STEP = {
  id: GIFT_FLOW_INFORMATION_ID,
  name: 'info',
  icon: 'information',
  route: 'accept/information',
  isVisible: true,
};

export const GIFT_FLOW_SHIPPING_STEP = {
  id: GIFT_FLOW_SHIPPING_ID,
  name: 'ship',
  icon: 'boxPackage',
  route: 'accept/shipping',
  isVisible: true,
};

export const GIFT_FLOW_CONFIRMATION_STEP = {
  id: GIFT_FLOW_CONFIRMATION_ID,
  name: 'confirm',
  icon: 'checkMark',
  route: 'accept/confirmation',
  isVisible: true,
};

export const GIFT_FLOW_THANKS_STEP = {
  id: GIFT_FLOW_THANKS_ID,
  name: 'thanks',
  icon: 'foldedHands',
  route: 'accept/thank-you',
  isVisible: true,
};

export const GIFT_FLOW_DONATE_STEP = {
  id: GIFT_FLOW_DONATE_ID,
  name: 'donate',
  icon: 'heartWithRibbon',
  route: 'marketplace',
  isVisible: true,
};

export const STEPS = {
  GIFT_FLOW_RPL_STEP,
  GIFT_FLOW_EXCHANGE_STEP,
  GIFT_FLOW_SCHEDULE_STEP,
  GIFT_FLOW_INFORMATION_STEP,
  GIFT_FLOW_SHIPPING_STEP,
  GIFT_FLOW_CONFIRMATION_STEP,
  GIFT_FLOW_THANKS_STEP,
  GIFT_FLOW_DONATE_STEP,
};
